const blog = (limit) => ({
    loading: false,
    showingResultCount: limit || 3,
    selectedTag: null,
    selectedHandle: null,
    articlesJSON: null,
    articles: [],
    initArticles: [],
    selectedBlogTags: [],
    isFiltered: false,
    init() {

        window.addEventListener("search-more", (event) => this.searchMore(event))
        this.isFiltered = false
        this.articlesJSON =  this.$el.querySelector("[data-articles]").innerHTML ||
                             document.querySelector("[data-articles]").innerHTML;
        this.initArticles = JSON.parse(this.articlesJSON).articles;

        if (this.initArticles) {
            this.selectedBlogTags = new Set();

            this.initArticles.forEach(article => {
                const articleTags = article.article.tags.split(",");
                articleTags.forEach(tag => {
                    if (tag.trim()) {
                        this.selectedBlogTags.add(tag.trim());
                    }
                });
            });

            this.selectedBlogTags = [...this.selectedBlogTags];
        }
    },
    searchMore(event) {
        this.loading = true;
        fetch(event.detail.new_url)
            .then(response => response.text())
            .then(data => {
                let html_div = document.createElement('div');
                html_div.innerHTML = data;

                const button = document.querySelector('#blog-pagination .button');
                const href = button.getAttribute('href');
                const url = new URL(href, window.location.origin);
                const pageValue = url.searchParams.get('page');
                if (pageValue && parseInt(pageValue) === parseInt(button.getAttribute('data-total-pages'))) {
                    document.querySelector('#blog-pagination').style.display = 'none';
                }

                let html_dom = html_div.querySelector('#blog-grid').innerHTML;

                if (document.querySelector('#blog-grid')) {
                    document.querySelector('#blog-grid').innerHTML += html_dom;
                }

                this.showingResultCount = document.querySelectorAll('.overview-card').length

                if (html_div.querySelector('#blog-pagination')) {
                    let pagination_dom = html_div.querySelector('#blog-pagination').innerHTML;
                    if (document.querySelector('#blog-pagination')) {
                        document.querySelector('#blog-pagination').innerHTML = pagination_dom;
                    }
                }
            })
            .catch(error => console.error('Error:', error))
            .finally(() => this.loading = false);
    },
    filterSliderByTag(event) {
        this.loading = true
        this.selectedTag = event.currentTarget.getAttribute("data-tag").split("/").pop()
        this.selectedHandle = event.currentTarget.getAttribute("data-handle")
        this.isFiltered = !!this.selectedTag

        if (this.selectedTag) {
            fetch(window.Shopify.routes.root + `search/suggest.json?q=${this.selectedTag}&resources[type]=article&resources[options][fields]=tag&limit=8`)
                .then((response) => response.json())
                .then((suggestions) => {
                        if (suggestions.message) return
                        this.loading = false
                        this.articles = suggestions.resources.results.articles
                    }
                );
        } else {
            this.loading = false
        }
    }
})

export default blog

document.addEventListener("alpine:init", () => {
    Alpine.data("blog", blog)
})
